import React, { useMemo } from 'react';
import { IRequestContext } from '@msdyn365-commerce/core';
import { AttributeValue, ProductPrice } from '@msdyn365-commerce/retail-proxy';
import { buildProductBadgeUrl } from '../../../common/utilities/productListExtensionHelpers';

const ProductBadge = ({
    attributeValues,
    productPrice,
    requestContext
}: {
    attributeValues?: AttributeValue[];
    requestContext: IRequestContext;
    productPrice?: ProductPrice;
}) => {
    const badgeValue = useMemo(() => {
        const discountAmount = productPrice?.DiscountAmount;
        if (discountAmount && discountAmount > 0) {
            process.env.NODE_ENV === 'development' && console.log('onsale', 'show', discountAmount);
            return 'on_sale';
        }

        var badgeAttr = attributeValues?.find(
            av => av.Name === 'Product Badge Status' && av.TextValue && av.TextValue.toLocaleLowerCase() !== 'none'
        );
        return badgeAttr?.TextValue ?? null;
    }, [productPrice, attributeValues]);

    if (badgeValue) {
        const badgeUrl = buildProductBadgeUrl(requestContext.locale, badgeValue, requestContext.apiSettings.baseImageUrl, '_PDP');
        const badgeName = badgeValue.replace(/_/, ' ');
        return <img className='msc-product__badge msc-product__badge--detail hei-badge' src={badgeUrl} alt={badgeName} />;
    }

    return null;
};

export { ProductBadge };
